import PageLoader from "@/components/PageLoader/PageLoader";

interface PageLoaderModuleProps {
  pagePath?: string
  hasAreaComponents?: (i:number) => void
}

function PageLoaderModule(props: Readonly<PageLoaderModuleProps>) {
    return (<PageLoader pagePath={props.pagePath} {...props}/>);
  }
    
export default PageLoaderModule;
